'use client';

import React, { useMemo } from 'react';

const STAR_COUNT = 80;

export default function StarField() {
  const stars = useMemo(() => {
    return Array.from({ length: STAR_COUNT }, (_, i) => ({
      id: `star-${i + 1}`,
      left: ((i * 137.508) % 100),
      top: ((i * 97.3) % 100),
      duration: 2 + (i % 5),
      delay: (i % 7) * 0.5,
      opacity: 0.1 + (i % 8) * 0.1,
      size: i % 3 === 0 ? 3 : i % 3 === 1 ? 2 : 1,
    }));
  }, []);

  return (
    <div className="star-field">
      {stars.map((star) => (
        <div
          key={star.id}
          className="star"
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            opacity: star.opacity,
            '--duration': `${star.duration}s`,
            '--delay': `${star.delay}s`,
          } as React.CSSProperties}
        />
      ))}
    </div>
  );
}